import React from 'react';
import { LockKeyhole, PackageCheck, Truck } from 'lucide-react';

const Reassurance = () => {
  const containerStyle = {
    display: 'flex',
    gap: '10px',
    justifyContent: 'center',
    flexWrap: 'wrap',
    margin: '0',
  };

  const blockStyle = {
    width: '27%',
    // backgroundColor: '#fff',
    borderRadius: '10px',
    // boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '20px',
  };

  return (
    <div>
      <div style={containerStyle}>
        <div style={blockStyle}>
          <LockKeyhole size={25} />
          <p>Paiement sécurisé</p>
        </div>

        <div style={blockStyle}>
          <PackageCheck size={25} />
          <p>Retour gratuit</p>
        </div>

        <div style={blockStyle}>
          <Truck size={25} />
          <p>Livraison offerte</p>
        </div>
      </div>
      <p style={{textAlign: 'center', fontWeight: 900, margin: 0}}>GARANTIE 2 ANS</p>
    </div>
  );
};

export default Reassurance;
